import React from 'react';

import { SecondaryButton, TextButton } from '@components/Button/variants';
import LazyImgixImage from '@components/LazyImgixImage';
import { getImgixSrc } from '@utils/images';

const Licensing = () => {
  return (
    <article
      id="Licensing"
      className="gap:48 mt-48 flex flex-col-reverse items-center justify-center sm:mb-80 sm:gap-32 md:mx-28 md:mb-96 md:grid-cols-2 md:flex-row xl:mx-[200px] xl:mb-112 xl:mt-64 xl:gap-[104px]"
    >
      <LazyImgixImage
        alt="Laptop with The Information's website on the screen"
        className="w-max-[409px] md:w-max-[425px] aspect-[1.3148] h-auto w-full sm:h-[311px] sm:w-[409px] md:h-[324px] md:w-[425px]"
        role="presentation"
        sizes="430px"
        src={getImgixSrc({
          path: 'corporate/laptop-with-the-information-site.png',
          isEnvDependent: false,
        })}
        wrapperClassName="leading-[0] mt-48 sm:mt-0 md:self-end h-auto sm:h-[311px] md:h-[324px] w-full sm:w-[409px] md:w-[425px]"
      />
      <div className="mx-16 flex flex-col items-center sm:mx-96 md:mx-0 md:items-start">
        <h2 className="my-0 self-start font-suisse-works text-headline-xs sm:text-headline-md">
          Content Licensing
        </h2>
        <p className="mb-0 mt-16 max-w-[512px] font-suisse-neue text-body-md sm:text-subheadline-md">
          Explore opportunities to publish The Information’s industry-leading journalism on your
          platform to engage your digital audience on a long-term basis.
        </p>
        <div className="flex w-full flex-col items-center md:w-auto">
          <SecondaryButton as="link" href="#IntroAndForm" className="anchor-link mt-32 sm:mt-48">
            Connect with the team
          </SecondaryButton>
          <TextButton as="link" href="#IntroAndForm" className="anchor-link mt-24 sm:mt-16">
            Go to top
          </TextButton>
        </div>
      </div>
    </article>
  );
};

export default Licensing;
